import { IReleaseSchema, releaseSchema, ReleaseService } from '@/api/release';
import { InputField } from '@/components/form/fields/InputField';
import { UploadField } from '@/components/form/fields/UploadField';
import { FormContainer, FormFooter } from '@/components/form/FormContainer';
import { Loading } from '@/components/Loading';
import { Section } from '@/components/Section';
import { OutlineButton } from '@/components/shared/button/OutlineButton';
import { useBackNavigate } from '@/utils/hooks/useBackNavigate';
import { zodResolver } from '@hookform/resolvers/zod';
import { Button, Dialog } from 'alurkerja-ui';
import React from 'react';
import { useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';

export const CreateEditRelease: React.FC = () => {
  const { id, releaseId } = useParams();
  const backNavigate = useBackNavigate();

  const {
    data,
    isFetching: isFetchLoading,
    refetch,
  } = ReleaseService.useGet(releaseId);
  const { mutate: create, isPending: isCreateLoading } =
    ReleaseService.useCreate();
  const { mutate: update, isPending: isUpdateLoading } =
    ReleaseService.useUpdate();
  const isLoading = isCreateLoading || isUpdateLoading;

  const form = useForm<IReleaseSchema>({
    resolver: zodResolver(releaseSchema),
    values: data,
  });

  const submitAction = (data: IReleaseSchema) => {
    data.project_id = id;

    if (releaseId) {
      update(data, {
        onSuccess: () => {
          Dialog.success({
            title: 'Berhasil',
            description: 'Berhasil update Release',
            callback: () => {
              refetch();
              backNavigate();
            },
          });
        },
      });
    } else {
      create(data, {
        onSuccess: () => {
          Dialog.success({
            title: 'Berhasil',
            description: 'Berhasil membuat Release',
            callback: backNavigate,
          });
        },
      });
    }
  };

  return (
    <Section title={releaseId ? 'Update Release' : 'Create Release'}>
      {isFetchLoading ? (
        <Loading />
      ) : (
        <FormContainer form={form} onSubmit={submitAction}>
          <div className="flex flex-row gap-10">
            <div className="flex flex-col w-full gap-3">
              <InputField
                name="name"
                label="Name"
                hasRequiredAsterisk
                placeholder="Release Name*"
              />

              <UploadField
                name="medias"
                label="Attachments"
                note="Allowed image format and max 2MB"
                type="image"
              />
            </div>

            <div className="flex flex-col w-full gap-3 ">
              <InputField
                name="start_date"
                label="Start Date"
                hasRequiredAsterisk
                type="date"
              />

              <InputField
                name="end_date"
                label="End Date"
                hasRequiredAsterisk
                type="date"
              />
            </div>
          </div>

          <FormFooter>
            <OutlineButton onClick={backNavigate}>Back</OutlineButton>

            <Button loading={isLoading}>
              {releaseId ? 'Update' : 'Create'}
            </Button>
          </FormFooter>
        </FormContainer>
      )}
    </Section>
  );
};
